import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _descriptor3, _HamburgerDropdownWrapper;
import Component from "@glimmer/component";
import { hash } from "@ember/helper";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { waitForPromise } from "@ember/test-waiters";
import { isDocumentRTL } from "discourse/lib/text-direction";
import { prefersReducedMotion } from "discourse/lib/utilities";
import { isTesting } from "discourse-common/config/environment";
import discourseLater from "discourse-common/lib/later";
import closeOnClickOutside from "../../modifiers/close-on-click-outside";
import SidebarHamburgerDropdown from "../sidebar/hamburger-dropdown";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
const CLOSE_ON_CLICK_SELECTORS = "a[href], .sidebar-section-header-button, .sidebar-section-link-button, .sidebar-section-link";
let HamburgerDropdownWrapper = (_class = (_HamburgerDropdownWrapper = class HamburgerDropdownWrapper extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "currentUser", _descriptor, this);
    _initializerDefineProperty(this, "siteSettings", _descriptor2, this);
    _initializerDefineProperty(this, "sidebarState", _descriptor3, this);
  }
  toggleNavigation() {
    this.args.toggleNavigationMenu(this.sidebarState.adminSidebarAllowedWithLegacyNavigationMenu ? "hamburger" : null);
  }
  click(e1) {
    if (e1.target.closest(CLOSE_ON_CLICK_SELECTORS)) {
      this.toggleNavigation();
    }
  }
  clickOutside(e1) {
    if (e1.target.classList.contains("header-cloak") && !prefersReducedMotion()) {
      const panel1 = document.querySelector(".menu-panel");
      const headerCloak1 = document.querySelector(".header-cloak");
      const finishPosition1 = isDocumentRTL() ? "340px" : "-340px";
      const panelAnimatePromise1 = panel1.animate([{
        transform: `translate3d(${finishPosition1}, 0, 0)`
      }], {
        duration: isTesting() ? 0 : 200,
        fill: "forwards",
        easing: "ease-in"
      }).finished.then(() => {
        if (isTesting()) {
          this.toggleNavigation();
        } else {
          discourseLater(() => this.toggleNavigation());
        }
      });
      const cloakAnimatePromise1 = headerCloak1.animate([{
        opacity: 0
      }], {
        duration: isTesting() ? 0 : 200,
        fill: "forwards",
        easing: "ease-in"
      }).finished;
      waitForPromise(panelAnimatePromise1);
      waitForPromise(cloakAnimatePromise1);
    } else {
      this.toggleNavigation();
    }
  }
  get forceMainSidebarPanel() {
    // NOTE: In this scenario, we are forcing the sidebar on admin users,
    // so we need to still show the hamburger menu and always show the main
    // panel in that menu.
    if (this.args.sidebarEnabled && this.sidebarState.adminSidebarAllowedWithLegacyNavigationMenu) {
      return true;
    }
    return false;
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    <div
      class="hamburger-dropdown-wrapper"
      {{! template-lint-disable no-invalid-interactive }}
      {{on "click" this.click}}
      {{! we don't want to close the hamburger dropdown when clicking on the hamburger dropdown itself
        so we use the secondaryTargetSelector to prevent that }}
      {{closeOnClickOutside
        this.clickOutside
        (hash
          targetSelector=".hamburger-panel"
          secondaryTargetSelector=".hamburger-dropdown"
        )
      }}
    >
      <SidebarHamburgerDropdown
        @forceMainSidebarPanel={{this.forceMainSidebarPanel}}
      />
    </div>
  
*/
{
  "id": "jiHLNIlM",
  "block": "[[[1,\"\\n    \"],[11,0],[24,0,\"hamburger-dropdown-wrapper\"],[4,[32,0],[\"click\",[30,0,[\"click\"]]],null],[4,[32,1],[[30,0,[\"clickOutside\"]],[28,[32,2],null,[[\"targetSelector\",\"secondaryTargetSelector\"],[\".hamburger-panel\",\".hamburger-dropdown\"]]]],null],[12],[1,\"\\n      \"],[8,[32,3],null,[[\"@forceMainSidebarPanel\"],[[30,0,[\"forceMainSidebarPanel\"]]]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[],false,[]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/header/hamburger-dropdown-wrapper.js",
  "scope": () => [on, closeOnClickOutside, hash, SidebarHamburgerDropdown],
  "isStrictMode": true
}), _HamburgerDropdownWrapper), _HamburgerDropdownWrapper), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "siteSettings", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sidebarState", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "toggleNavigation", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleNavigation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "click", [action], Object.getOwnPropertyDescriptor(_class.prototype, "click"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clickOutside", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clickOutside"), _class.prototype)), _class);
export { HamburgerDropdownWrapper as default };